import numeral from 'numeral';
import PendoLoading from '../../directives/loading/pendo-loading.js';
import PendoIcon from '../icon/pendo-icon.vue.js';
import PendoTooltip from '../../directives/tooltip/pendo-tooltip.js';
import { isValidHex, getContrastingColor } from '../../utils/color.js';
import { shouldAttachOverflowTooltip } from '../../utils/dom.js';

var script = {
  name: 'PendoMetric',
  components: {
    PendoIcon
  },
  directives: {
    PendoLoading,
    PendoTooltip
  },
  props: {
    size: {
      type: String,
      default: 'medium',
      validator: size => ['large', 'medium', 'small', 'mini'].includes(size)
    },
    value: {
      type: [Number, String],
      default: null
    },
    format: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: null
    },
    sublabel: {
      type: String,
      default: null
    },
    topLabel: {
      type: String,
      default: null
    },
    topSublabel: {
      type: String,
      default: null
    },
    trendingLabel: {
      type: String,
      default: null
    },
    trendingColor: {
      type: String,
      default: null,
      validator: trendingColor => ['green', 'orange', 'gray'].includes(trendingColor)
    },
    color: {
      type: String,
      default: '#2a2c35'
    },
    loading: {
      type: Boolean,
      default: false
    },
    alignment: {
      type: String,
      default: 'center',
      validator: alignment => ['center', 'left', 'inline'].includes(alignment)
    },
    icon: {
      type: String,
      default: null
    },
    iconBackgroundColor: {
      type: String,
      default: null,
      validator: color => isValidHex(color)
    }
  },
  data() {
    return {
      tooltipTimeout: null,
      activeTooltip: null
    };
  },
  computed: {
    formattedValue() {
      return this.format ? numeral(this.value).format(this.format) : this.value;
    },
    isCircleIcon() {
      return this.icon === 'circle' || this.icon === 'circle-striped';
    },
    iconConfig() {
      if (this.isCircleIcon) {
        return {
          type: this.icon,
          fill: this.iconBackgroundColor,
          stroke: this.iconBackgroundColor,
          size: 10
        };
      }
      return {
        type: this.icon,
        stroke: this.iconBackgroundColor ? getContrastingColor(this.iconBackgroundColor) : '#2A2C35',
        strokeWidth: 2.5,
        size: 12
      };
    },
    iconContainerStyles() {
      if (!this.isCircleIcon && this.iconBackgroundColor) {
        return {
          backgroundColor: this.iconBackgroundColor
        };
      }
      return {};
    },
    showTrending() {
      return this.trendingLabel && this.trendingColor;
    },
    trendingLoadingOverlayHeight() {
      switch (this.size) {
        case 'large':
          return 32;
        case 'medium':
          return 30;
        case 'small':
          return 24;
        default:
          return 18;
      }
    },
    loadingOverlayHeight() {
      switch (this.size) {
        case 'large':
          return 36;
        case 'medium':
          return 32;
        case 'small':
          return 28;
        default:
          return 20;
      }
    }
  },
  methods: {
    onOptionMouseenter(labelType) {
      const showOverflowTooltip = shouldAttachOverflowTooltip(this[labelType], this.$refs[labelType]);
      if (showOverflowTooltip) {
        clearTimeout(this.tooltipTimeout);
        this.tooltipTimeout = setTimeout(() => {
          this.activeTooltip = labelType;
        }, 300);
      }
    },
    onOptionMouseleave() {
      clearTimeout(this.tooltipTimeout);
      this.activeTooltip = null;
    },
    showOverflowTooltip(labelType) {
      return this.activeTooltip === labelType;
    }
  }
};

export { script as default };
//# sourceMappingURL=pendo-metric.vue2.js.map
